import script from "./RoundLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundLoader.vue?vue&type=script&setup=true&lang=js"

import "./RoundLoader.vue?vue&type=style&index=0&id=1be92178&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be92178"]])

export default __exports__